/*
 * @Author: xcy
 * @Date: 2021-06-07 20:47:05
 * @LastEditTime: 2022-12-01 15:25:14
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @Description: 
 */
import axios from "axios";

const instance = axios.create({
  //  baseURL:'http://192.168.5.111:8082', //sit
  // baseURL:'https://apitracechaintea.v-m.site', //正式域名-旧
  // baseURL: 'https://sitapigateway.v-m.site/chain/chainindustry/v1.0.0/', //sit域名
  // newBaseURL:'https://sitapigateway.v-m.site/chain/chainindustry/v1.0.0/', //新的地址
  // baseURL: "https://uatapitracechaintea.v-m.site", //uat域名
  baseURL: 'https://apigateway.klyun.com.cn/chain/chainindustry/v1.0.0',//正式域名
  // baseURL: 'https://apitracechaintea.lianbaicha.com',//正式域名-right
});
axios.interceptors.request.use(
  (config) => {
    // 开始加载动画
    // 设置统一的请求头
    // config.headers.Authorization = sessionStorage.token;
    config.headers["Referrer-Policy"] = "unsafe-url";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
console.log(instance)
export default instance;
